// ---------------------------------------------------------------------------
// Mensajes de error centralizados
// ---------------------------------------------------------------------------
export const ERRORS = {
    NO_PRODUCT: "Por favor, selecciona un producto.",
    NO_WALL_WIDTH: "Por favor, ingresa el ancho del muro en metros.",
    NO_WALL_HEIGHT: "Por favor, ingresa la altura del muro en metros.",
    NO_AREA: "Por favor, ingresa el área total de tu espacio en m².",
    NO_DIMENSIONS: "Por favor, ingresa el largo y ancho de tu espacio.",
    NO_RESULT: "Primero calcula tu material.",
    NO_NAME: "Por favor, ingresa tu nombre.",
    INVALID_PHONE: "Por favor, ingresa un número de WhatsApp válido a 10 dígitos.",
    INVALID_EMAIL: "Por favor, ingresa un correo electrónico válido.",
    HUBSPOT_FAIL: "No pudimos registrar tu solicitud en este momento. Te redirigiremos a WhatsApp para continuar.",
};